import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {assertUnreachable} from 'common/util/typescript';
import {trackDataClassificationError, trackMissingDatagroupError} from 'common/report/queries/utils';
import {WARNING_THEMES} from 'common/components/warning/types';

import template from './index.jade';
import css from './index.styl?inline';

export enum DISPLAY_TYPE {
  DEFAULT = `default`,
  ERROR = `error`,
  SENSITIVE = `sensitive`,
  MISSING_MAPPED_DATAGROUP = `missing-mapped-datagroup`,
}

export interface EmptyReportHeroJsxProps {
  attrs?: {
    'header-text': string;
    'body-text'?: string;
    'cta-href'?: string;
    'cta-text'?: string;
    type?: DISPLAY_TYPE;
    report?: string;
  };
}
export class EmptyReportHero extends Component<EmptyObj, EmptyReportHeroJsxProps['attrs']> {
  static get attrsSchema(): AttrsSchema<EmptyReportHeroJsxProps['attrs']> {
    return {
      ...super.attrsSchema,
      'header-text': `string`,
      'body-text': `string`,
      'cta-href': `string`,
      'cta-text': `string`,
      type: {type: `string`, default: DISPLAY_TYPE.DEFAULT, enum: Object.values(DISPLAY_TYPE)},
      report: {type: `string`, description: `report name`},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        handleCtaClick: () => this.dispatchEvent(new CustomEvent(`ctaClick`)),
        getWarningThemeFromDisplayType: (displayType: DISPLAY_TYPE): WARNING_THEMES => {
          switch (displayType) {
            case DISPLAY_TYPE.DEFAULT:
              return WARNING_THEMES.DEFAULT;
            case DISPLAY_TYPE.ERROR:
              return WARNING_THEMES.ERROR;
            case DISPLAY_TYPE.SENSITIVE:
              return WARNING_THEMES.SENSITIVE;
            case DISPLAY_TYPE.MISSING_MAPPED_DATAGROUP:
              return WARNING_THEMES.ERROR_DARK;
            default:
              assertUnreachable(displayType);
          }
        },
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.attr(`type`) === DISPLAY_TYPE.SENSITIVE && !!this.attr(`report`)) {
      trackDataClassificationError(this.attr(`report`));
    }
    if (this.attr(`type`) === DISPLAY_TYPE.MISSING_MAPPED_DATAGROUP && !!this.attr(`report`)) {
      trackMissingDatagroupError(this.attr(`report`));
    }
  }
}

export const EmptyReportHeroEl = defineAndMakeJsxFactory<EmptyReportHeroJsxProps>(
  `mp-empty-report-hero`,
  EmptyReportHero,
);
